<template>
    <b-row no-gutters class="border-light-grey">
        <b-col cols="12">
            <b-nav class="justify-content-start">
                <b-nav-item
                    
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 6}"
                    :to="generateLink(true, 'overview')"
                >
                    {{ $t('sensors-page.overview.tab-name') }}
                </b-nav-item>
                <b-nav-item
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 1}"
                    :to="generateLink(true, 'controller')"
                >
                    {{ $t('sensors-page.controller.tab-name') }}
                </b-nav-item>
                <b-nav-item
                    v-if="getDamPiezometers[1].length !== 0"
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 2}"
                    :to="generateLink(true, 'piezometer')"
                >
                    {{ $t('sensors-page.piezometers.tab-name') }}
                </b-nav-item>

                <b-nav-item
                    v-if="getDamInclinometersNew.length !== 0"
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 3}"
                    :to="generateLink(true, 'inclinometer')"
                >
                    {{ $t('sensors-page.inclinometers.tab-name') }}
                </b-nav-item>

                <!-- <b-nav-item
                    v-if="getDamLevelmeters[1].length !== 0"
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 4}"
                    :to="generateLink(true, 'levelmeter')"
                >
                    {{ $t('sensors-page.levelmeters.tab-name') }}
                </b-nav-item> -->

                <b-nav-item
                    class="py-1 py-sm-2 px-md-3 custom-nav-item"
                    :class="{'custom-active-nav-item': activeTab === 5}"
                    :to="generateLink(false)"
                >
                    {{ $t('dashboard.profile') }}
                </b-nav-item>

            </b-nav>
        </b-col>
    </b-row>
</template>

<script>
    // mixins
    import RouteWatcher from "../../mixins/RouteWatcher";
    // vuex
    import {mapGetters, mapActions} from "vuex";
    import {
        GET_TAB_REDIRECT,
        SET_TAB_REDIRECT
    } from "../../store/actions/sensors";
    /**
     * Serves as a tab navigation.
     */

    export default {
        name: "TabsBar",
        mixins: [RouteWatcher],
        computed: {
            ...mapGetters([
                GET_TAB_REDIRECT,
                "getDamInclinometersNew",
                "getDamPiezometers",
                "getDamLevelmeters"])
        },
        methods: {
            ...mapActions([SET_TAB_REDIRECT]),
            generateLink(isGoingSensors, tabName=null) {
                let name = 'sensors';
                if (!isGoingSensors) {
                    name = 'profile';
                }

                let backToObj = {name};
                if (this.$route.params.id) {
                    backToObj['params'] = {id: this.$route.params.id};
                }
                if (tabName) {
                    backToObj['query'] = {tab: tabName};
                }
                return backToObj;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .border-light-grey {
        border-bottom: 1px solid $lightGrey;
        .custom-nav-item {
            a {
                text-align: left;
                font: normal normal 300 16px/22px Nunito, sans-serif;
                letter-spacing: 0;
                color: $darkColor !important;
                opacity: 1;
            }
            &:hover a {
                color: $menuBlue !important;
            }
            &.custom-active-nav-item {
                border-bottom: 3px solid $menuBlue;
                a {
                    color: $menuBlue !important;
                    font-weight: 600;
                }
            }
        }
    }

    @media screen and (max-width: 762px) {
        .border-light-grey {
            .custom-nav-item {
                a {
                    font: normal normal 300 13px/20px Nunito, sans-serif;
                }

            }
        }
    }
</style>